'use client';

import { useEffect } from 'react';

import { useSetAtom } from 'jotai';

import { formErrorsAtom } from '@core/Atoms/Pdp/FormErrors.atom';

export const ResetLeadFormErrors = () => {
  const setFormErrors = useSetAtom(formErrorsAtom);
  useEffect(() => {
    setFormErrors({});
  }, []);
  return null;
};
